<div class="card mb-2">
	<div class="row">
		<h2>Traslado desde Caja hacia Banco <span style="font-weight: 60;"></span></h2>
	</div>
	<div class="card-header">
		<h3>Datos del Traslado</h3>
	</div>
	<div class="card-body">
		<div class="row mb-2">
			<div class="col-md-6">
				<div class="form-group">
					<label for="cash">Caja:
						<span style="color: red;" data-tooltip="Campo requerido" data-tooltip-position="top">*</span>
					</label>
					<select name="cashier1" id="cashier1" [(ngModel)]="request.issuerCash"
						(ngModelChange)="updateCashAmounts()" class="form-select">
						<option [ngValue]="undefined">Seleccione una caja</option>
						<option *ngFor="let cash of cashiers" [ngValue]="cash.id">{{cash.name}}</option>
					</select>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label for="bank">Banco:
						<span style="color: red;" data-tooltip="Campo requerido" data-tooltip-position="top">*</span>
					</label>
					<select name="bank" id="bank" [(ngModel)]="request.receivingBank" class="form-select">
						<option value="undefined">Seleccione una banco</option>
						<option *ngFor="let bank of banks" value="{{bank.id}}">{{bank.accountNumber}} - {{bank.alias}}
						</option>
					</select>
				</div>
			</div>
		</div>

		<div class="row mb-2">
			<h3 style="font-size:16px; font-weight: 700; margin-top: 2em; margin-bottom: 1em;">Datos de efectivo en
				caja: </h3>
			<span class="text-muted">Efectivo en {{ amountQ | currency:'GTQ ':'symbol':'1.2-2' }}</span>
			<span class="text-muted">Efectivo en {{ amountDollar | currency:'USD ':'symbol':'1.2-2' }}</span>
			<span class="title-hr">
				<hr />Informacion
				<hr />
			</span>
			<div class="col-sm form-group">
				<label for="cash">Referencia:</label>
				<div class="input-group">
					<input type="number" placeholder="Ingresa la referencia" [(ngModel)]="request.docNumber"
						class="form-control" id="transfer" name="transfer">
				</div>
			</div>
			<div class="col-sm form-group">
				<label for="transfer-amount">Monto(Q):</label>
				<div class="input-group">
					<label for="" class="input-group-text">Q.</label>
					<input type="number" min="0" [(ngModel)]="transferDetail.amount" class="form-control" id="transfer"
						name="transfer" placeholder="0.00">
				</div>
			</div>
			<div class="col-sm form-group">
				<label for="transfer-amount">Monto($):</label>
				<div class="input-group">
					<label for="" class="input-group-text">$.</label>
					<input type="number" min="0" [(ngModel)]="auxDollar" class="form-control" id="transfer"
						name="transfer" placeholder="0.00">
				</div>
			</div>
			<div class="col-sm form-group">
				<label for="card">Descripción:</label>
				<div class="input-group">
					<input type="text" placeholder="Ingresa una descripción" [(ngModel)]="request.description"
						class="form-control" id="transfer" name="transfer">
				</div>
			</div>
			<div class="col-sm form-group">
				<label for="check">Fecha:</label>
				<div class="input-group">
					<input type="date" min="0" [disabled]="request.rollback" [(ngModel)]="auxDate" class="form-control" id="transfer" name="transfer"
						placeholder="0.00">
				</div>
			</div>
			<div class="col-sm form-group">
				<label for="check">Imagen:</label>
				<span class="span-button" [class.opacity-20]="!request.image" (click)="selectImage()">
					<img id="image" src="{{request.image?request.image:'../../../../../assets/img/nophoto.svg'}}"
						alt="Sin foto" class="no-photo" width="auto" height="50%"
						(error)="$event.target.src = '../../../../../assets/img/nophoto.svg'">
					<div class="container-image-control">
						<i [class.contrast]="contrast" [ngClass]="request.image?'fa fa-edit':'fa fa-plus'"></i>
					</div>
					<input type="file" #file (change)="changeFile($event)" accept="image/*" class="file-hide" name="file"
						id="file">
				</span>
			</div>
		</div>

		<div class="buttons">
			<button class="btn btn-danger" type="button" (click)="reset()"><i class="fa fa-ban"></i>CANCELAR</button>
			<app-loading-button [object]="buttonSave" [disabled]="request.issuerCash==0 || !request.image" (clicked)="save()"></app-loading-button>
		</div>
	</div>
</div>